enum TransactCampusCardHostSystem {
  TSE = 'tse',
  IDX = 'idx',
}

export { TransactCampusCardHostSystem };
